

module.exports = __webpack_require__.stylable.create(
    "StatusIndicator1811061344",
    {"classes":{"root":"StatusIndicator1811061344__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".StatusIndicator1811061344__root{width:18px;height:18px;color:#ee5951}.StatusIndicator1811061344__root.StatusIndicator1811061344---status-7-warning{color:#fdb10c}.StatusIndicator1811061344__root.StatusIndicator1811061344---status-7-warning svg{margin:1px 0}",
    2,
    "StatusIndicator1811061344",
    __webpack_require__.stylable.$
);
